import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-config',
  templateUrl: './view-config.component.html',
  styleUrls: ['./view-config.component.scss']
})
export class ViewConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
